import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  standalone: false
})
export class ButtonComponent implements OnInit {
  @Input() labelKey: string;
  @Input() classNames: string;
  @Input() isLoading: boolean;
  @Input() isDisabled: boolean;
  @Output() clicked: EventEmitter<void> = new EventEmitter<void>();

  constructor() {}

  ngOnInit(): void {}
}
